module.exports = __webpack_public_path__ + "img/ownership.1588c114.svg";